import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  statusText: {
    color: semanticColors.foreground.secondary,
  },
  actionButtons: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
});
